import { upload as uploadFile, db, cache, cancel } from 'utils';
import { objToArray } from 'selectors';
import { PENDING, LOADING, FAIL, SUCCESS, FINISHED } from 'constants';
export const ADD_UPLOADER = 'UPLOADER.ADD_UPLOADER';
export const LOAD_UPLOADER = 'UPLOADER.LOAD_UPLOADER';
export const UPDATE_UPLOADER = 'UPLOADER.UPDATE_UPLOADER';

export const addFiles = ({ g_id, u_id, files, onSuccess }) => (dispatch, getState) => {
  dispatch(initializeUploadGroup({ g_id, u_id }));
  const user_id = getState().user.id;
  files.forEach(file => {
    file.file_id = file.file_id || db.key();
    cache.set(`uploading_${file.file_id}`, file);
    let upload = { u_id, g_id, file_id: file.file_id, user_id, status: PENDING, name: file.name, uri: file.uri, original_uri: file.original_uri };
    cache.set(`uploading_meta_${file.file_id}`, { upload, update: (...arg) => dispatch(update(...arg)) });
    dispatch({ type: ADD_UPLOADER, payload: { id: g_id, data: upload, key: 'file_id' }, attr_name: u_id });
  });
  cache.set(`onFinishedUploading_${g_id}${u_id}`, onSuccess);
  dispatch(startUploader({ g_id, u_id }));
};

const startUploader = ({ g_id, u_id }) => (dispatch, getState) => {
  const state = getState();
  const pending = objToArray(state, 'uploader', g_id, u_id, null, pendingFilter, PENDING);
  const loading = objToArray(state, 'uploader', g_id, u_id, null, loadingFilter, LOADING);
  pending.length && !loading.length && uploadFile(pending[0], (...arg) => dispatch(update(...arg)));
};

const pendingFilter = file => file.status === PENDING;
const loadingFilter = file => file.status === LOADING;
const failFilter = file => file.status === FAIL;
const successFilter = file => file.status === SUCCESS;

const update = upload => dispatch => {
  if (upload.status !== FINISHED) {
    dispatch({ type: UPDATE_UPLOADER, payload: { id: upload.g_id, data: upload, key: 'file_id' }, attr_name: upload.u_id });
    dispatch(startUploader({ g_id: upload.g_id, u_id: upload.u_id }));
    dispatch(onUploadingFinished(upload));
  }
};

const initializeUploadGroup = ({ g_id, u_id }) => (dispatch, getState) => {
  const uploader = getState().uploader[g_id];
  !uploader && dispatch({ type: LOAD_UPLOADER, payload: { id: g_id, data: {} }, attr_name: u_id });
};

const onUploadingFinished = ({ g_id, u_id }) => (dispatch, getState) => {
  const state = getState();
  const pending = objToArray(state, 'uploader', g_id, u_id, null, pendingFilter, PENDING).length;
  const loading = objToArray(state, 'uploader', g_id, u_id, null, loadingFilter, LOADING).length;
  const fail = objToArray(state, 'uploader', g_id, u_id, null, failFilter, FAIL).length;
  const success = objToArray(state, 'uploader', g_id, u_id, null, successFilter, SUCCESS).length;

  if (!pending && !loading && !fail && success) {
    const callback = cache.get(`onFinishedUploading_${g_id}${u_id}`);
    callback && callback();
  }
};

export const markFinished = ({ g_id, u_id }) => (dispatch, getState) => {
  const uploads = getState().uploader[g_id][u_id];

  Object.values(uploads).forEach(upload => {
    upload.status === LOADING && cancel(upload.file_id);
    dispatch({ type: UPDATE_UPLOADER, payload: { id: upload.g_id, data: { ...upload, status: FINISHED }, key: 'file_id' }, attr_name: upload.u_id });
  });
  cache.remove(`onFinishedUploading_${g_id}${u_id}`);
};

export const cancelUpload = ({ file_id }) => cancel(file_id);

export const getBlobURI = id => {
  const blob = cache.get(`uploading_${id}`);
  return blob ? blob.uri : null;
};



// WEBPACK FOOTER //
// ./src/actions/uploader.js